import styled from 'styled-components';
import { zIndex } from 'styles';

export default {
  MenuContainer: styled.div`
    z-index: ${zIndex.MENU}; /* Has to appear above all components hence the z-index has to be higher than others */
    &[data-popper-reference-hidden^=true] {
      visibility: hidden;
      pointer-events: none;
    }
  `
};